import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import activePage from './activePage';
import interviewResult from './interviewResult';

export default combineReducers({
  router: routerReducer,
  page: activePage,
  interview: interviewResult
});



// WEBPACK FOOTER //
// ./src/modules/index.js